<script>
	import ClientSelect from './ClientSelect.svelte';
  import { userStore } from '../services/session'
  import { replace, location } from 'svelte-spa-router'


  let userConfirm = false
  export let acls = []
  export let component
  export let params = {}

  userStore.subscribe(user => {
    if(!user.login)
      replace('/login')
    else {
      user.isAuth
        .then(isAuthenticated => {
          if(isAuthenticated) {
            // Permitimos acceso si el usuario tiene permiso de acceso para ALGUNA de las ACLs
            if( $location !== '/' && !acls.some(acl => user.getAcl(acl)))
              replace('/')
            else 
              userConfirm = true
          }
          else
            replace('/login')
        }).catch(err => replace('/login')) 
    }
  })

</script>

<ClientSelect/>
{#if userConfirm}
<svelte:component this={component} {...$$restProps} {...params}/>
{/if}
